module.exports = __webpack_public_path__ + "img/statistics-b.eec33d44.svg";